// removed by extract-text-webpack-plugin
module.exports = {"container":"_1G4Z0arsw6-t9mWBG2SITA","coin":"_33prmC3Hkk6z4zaZiYCQbH"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Home/Layout/Footer/Coins/styles.css
// module id = 1067
// module chunks = 21